import React from 'react';
import { useSelector } from 'react-redux';

import BrandGraph from './brand-graph/BrandGraph';
import NoBrand from './no-brand/NoBrand';
import BrandSocials from './brand-socials/BrandSocials';
import BrandTable from './brand-table/BrandTable';
import { selectChosenDomainEntry } from '../../redux/sonar/sonarSelectors';

function Brand() {
  const chosenDomain = useSelector(selectChosenDomainEntry);

  if (!chosenDomain) {
    return <NoBrand />;
  }

  return (
    <>
      <BrandTable domainEntry={chosenDomain} />
      <BrandSocials chosenDomain={chosenDomain} />
      <BrandGraph chosenDomain={chosenDomain} />
    </>
  );
}

export default Brand;
